import React from "react";

function TodoListIcon({ size = 32, fill = "#2F80ED", stroke = "#2F80ED" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="8"
        fill={`${fill}1A`}
      />
      <rect
        x="7"
        y="8"
        width="18"
        height="3"
        rx="1.5"
        fill={stroke}
        opacity="0.8"
      />
      <rect
        x="7"
        y="14"
        width="18"
        height="3"
        rx="1.5"
        fill={stroke}
        opacity="0.6"
      />
      <rect
        x="7"
        y="20"
        width="11"
        height="3"
        rx="1.5"
        fill={stroke}
        opacity="0.5"
      />
      <path
        d="M24 20L21.75 22.25L20.5 21"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TodoListIcon;
